import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
let SaveSearchService = class SaveSearchService {
    savedSearchOption;
    savedDataResultsAsObservable = null;
    constructor() { }
    clearSavedSearchResults() {
        this.savedDataResultsAsObservable = null;
        this.savedSearchOption = null;
    }
    setSavedSearchOption(moduleName, searchOption) {
        this.savedSearchOption = new Map();
        this.savedSearchOption.set(moduleName, searchOption);
    }
    getSavedSearchOption() {
        return this.savedSearchOption;
    }
    getSavedDataResultsAsObservable() {
        return this.savedDataResultsAsObservable;
    }
    setSavedDataResultsAsObservable(savedDataResultsAsObservable) {
        this.savedDataResultsAsObservable = savedDataResultsAsObservable;
    }
    static ctorParameters = () => [];
};
SaveSearchService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SaveSearchService);
export { SaveSearchService };
